const webToNativeDynamicExpansion = {},
  webToNativeExpansion = {};
export { webToNativeDynamicExpansion, webToNativeExpansion };
//# sourceMappingURL=webToNativeProps.mjs.map
